import * as THREE from "three";
import {ModelStore} from "./utils";

export function drawTex3(x1, y1, z1,
                  x2, y2, z2,
                  x3, y3, z3,
                  x4, y4, z4,
                  texture) {
    let geometry = new THREE.Geometry();
    geometry.vertices.push(new THREE.Vector3(x1, y2, z1)); //0, 0
    geometry.vertices.push(new THREE.Vector3(x3, y3, z3)); //0, 1
    geometry.vertices.push(new THREE.Vector3(x4, y4, z4)); //1, 1
    geometry.vertices.push(new THREE.Vector3(x2, y2, z2)); //1, 0
    geometry.faces.push(new THREE.Face3(0, 1, 2));
    geometry.faceVertexUvs[0].push([new THREE.Vector2(0, 0),
        new THREE.Vector2(0, 1),
        new THREE.Vector2(1, 1)]);

    //geometry.faces.push( new THREE.Face3( 3, 0, 2 ) );
    //geometry.faceVertexUvs[0].push([new THREE.Vector2(1,0),
    //                  new THREE.Vector2(0,0),
    //                  new THREE.Vector2(1,1)]);

    geometry.computeFaceNormals();
    geometry.computeVertexNormals();
    texture.side = THREE.DoubleSide;

    let mesh = new THREE.Mesh(
        geometry,
        texture
    );
    mesh.position.set(0, 0, 0);
    return mesh;
}

export function drawBox() {

    let uniforms = {
        xPosition: { type: "f", value: 0.0 },
        yPosition: { type: "f", value: 0.0 },
        zPosition: { type: "f", value: 0.0 },
        spriteTilesWide: { type: "f", value: 1.0 },
        spriteTilesTall: { type: "f", value: 1.0 },
        spriteIndex: { type: "f", value: 0.0 },
        spriteIndexX: { type: "f", value: 0.0 },
        spriteIndexY: { type: "f", value: 0.0 },
        time: { type: "f", value: 0.0 },
        diffuse: { type: "c", value: new THREE.Color(0xaaeeff) },
        resolution: { type: "v2", value: new THREE.Vector2() },
        mouse: { type: "v2", value: new THREE.Vector2() },
        lightPosition: { type: "v3", value: new THREE.Vector3() },
        cameraPos: { type: "v3", value: new THREE.Vector3() },
        t0: { type: 't', value: TextureStore.getTexture("fantasy_world") },
    };

    let vertexShader = ShaderStore.get("v_basic");
    let fragmentShader = ShaderStore.get("f_tex_tiled");

    let shaderMaterial = new THREE.ShaderMaterial({
        uniforms: jQuery.extend(true, {}, uniforms),
        transparent: true,
        vertexColors: THREE.FaceColors,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader
    });

    shaderMaterial.uniforms.spriteTilesWide.value = 55.0;
    shaderMaterial.uniforms.spriteTilesTall.value = 37.0;

    // 4, 26 was the original source... so X stays the same.. +1 to the y index
    // and invert it. (depending on the sheet i guess)
    shaderMaterial.uniforms.spriteIndexX.value = 4.0;
    shaderMaterial.uniforms.spriteIndexY.value = 37 - 27.0;

    let geometry = new THREE.BoxBufferGeometry(40, 40, 40);
    let mesh = new THREE.Mesh(geometry, shaderMaterial);
    
    mesh.userData = "AnthonyBox";
    return mesh;
}

// bottomLeft, bottomRight, topLeft, topRight
// draw a simple quad
export function drawTex4(x1, y1, z1,
                  x2, y2, z2,
                  x3, y3, z3,
                  x4, y4, z4,
                  texture) {
    let geometry = new THREE.Geometry();

    geometry.vertices.push(new THREE.Vector3(x1, y2, z1)); //0, 0
    geometry.vertices.push(new THREE.Vector3(x3, y3, z3)); //0, 1
    geometry.vertices.push(new THREE.Vector3(x4, y4, z4)); //1, 1
    geometry.vertices.push(new THREE.Vector3(x2, y2, z2)); //1, 0


    let A = new THREE.Vector2(0, 0);
    let B = new THREE.Vector2(0, 1);
    let C = new THREE.Vector2(1, 1);
    let D = new THREE.Vector2(1, 0);

    geometry.faces.push(new THREE.Face3(0, 1, 2));


    geometry.faceVertexUvs[0].push([A, B, C]);

    geometry.faces.push(new THREE.Face3(3, 0, 2));

    geometry.faceVertexUvs[0].push([D, A, C]);

    geometry.computeFaceNormals();
    geometry.computeVertexNormals();
    texture.side = THREE.DoubleSide;

    let mesh = new THREE.Mesh(
        geometry,
        texture
    );

    mesh.position.set(0, 0, 0);
    return mesh;
}

export function updateTex4(quad, x1, y1, z1,
                    x2, y2, z2,
                    x3, y3, z3,
                    x4, y4, z4) {
    quad.vertices = [];
    quad.vertices.push(new THREE.Vector3(x1, y2, z1)); //0, 0
    quad.vertices.push(new THREE.Vector3(x3, y3, z3)); //0, 1
    quad.vertices.push(new THREE.Vector3(x4, y4, z4)); //1, 1
    quad.vertices.push(new THREE.Vector3(x2, y2, z2)); //1, 0
    bgPlane.__dirtyVertices = true;
}

// blank mesh no pre-built animation or materials
// but has texture coords
export function genTex4(x1, y1, z1,
                 x2, y2, z2,
                 x3, y3, z3,
                 x4, y4, z4,
                 material) {
    let geometry = new THREE.Geometry();

    geometry.vertices.push(new THREE.Vector3(x1, y2, z1)); //0, 0
    geometry.vertices.push(new THREE.Vector3(x3, y3, z3)); //0, 1
    geometry.vertices.push(new THREE.Vector3(x4, y4, z4)); //1, 1
    geometry.vertices.push(new THREE.Vector3(x2, y2, z2)); //1, 0

    geometry.faces.push(new THREE.Face3(0, 1, 2));
    geometry.faceVertexUvs[0].push([new THREE.Vector2(0, 0),
        new THREE.Vector2(0, 1),
        new THREE.Vector2(1, 1)]);

    geometry.faces.push(new THREE.Face3(3, 0, 2));
    geometry.faceVertexUvs[0].push([new THREE.Vector2(1, 0),
        new THREE.Vector2(0, 0),
        new THREE.Vector2(1, 1)]);

    geometry.computeFaceNormals();
    geometry.computeVertexNormals();

    for (let i = 0; i < geometry.vertices.length; i++) {
        let point = geometry.vertices[i];
        let color = new THREE.Color(0xffffff);
        geometry.colors[i] = color; // use this array for convenience
    }

    let mesh = new THREE.Mesh(
        geometry,
        m
    );

    mesh.position.set(0,
        0,
        0);

    return mesh;
}

export function drawTex(x1, y1, x2, y2) {
    let z = -camera.far;
    z = 0;

    let width = 0;

    if (x1 > x2) {

    } else {

    }

    // since this a quad
    let min = x1;
    let max = x2;

    let geometry = new THREE.Geometry();
    z = CameraPlane.farTopRight.z;

    geometry.vertices.push(new THREE.Vector3(x1, y2, z)); //0, 0
    geometry.vertices.push(new THREE.Vector3(x1, y1, z)); //0, 1
    geometry.vertices.push(new THREE.Vector3(x2, y1, z)); //1, 1
    geometry.vertices.push(new THREE.Vector3(x2, y2, z)); //1, 0
    geometry.dynamic = true;

    //new Vector2 (0, 0), new Vector2 (0, 1), new Vector2 (1, 1),  new Vector2 (1, 0)

    // geometry.faceVertexUvs[ 0 ][ faceIndex ][ vertexIndex ]
    geometry.faces.push(new THREE.Face3(0, 1, 2));
    geometry.faceVertexUvs[0].push([new THREE.Vector2(0, 0),
        new THREE.Vector2(0, 1),
        new THREE.Vector2(1, 1)]);

    geometry.faces.push(new THREE.Face3(3, 0, 2));
    geometry.faceVertexUvs[0].push([new THREE.Vector2(1, 0),
        new THREE.Vector2(0, 0),
        new THREE.Vector2(1, 1)]);

    // apply the needed uvs
    //geometry.faceVertexUvs[0] = [];

    geometry.faceVertexUvs[0] = AnimatedFrame.getFrameCoords(0, 0);

    // apply the needed UVs to the quad
    geometry.computeFaceNormals();
    geometry.computeVertexNormals();
    let mat = new THREE.MeshBasicMaterial({
        color: tinycolor({
            r: 255,
            g: 255,
            b: 255
        }).toHexString(),
        wireframe: false,
        map: TextureStore.getTexture("tile")
    });

    mat.shading = THREE.FlatShading;
    mat.side = THREE.DoubleSide;

    let mesh = new THREE.Mesh(
        geometry,
        mat
    );
    mesh.position.set(0,
        0,
        0);
    scene.add(mesh);
    let object = new AnimatedObject();
    object.material = mat;
    object.geometry = geometry;
    object.mesh = mesh;
    object.addAnimation("default", [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
    object.addAnimation("backwards", [11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0]);
    object.startAnimation("default");
    ObjectStore.addObject(object);
}

// this just draws a solid quad
// who knows where this is actually placed in the scene?
export function drawTexQuad() {
    let min = -100.0;
    let max = 100.0;

    let origin = {
        x: 0,
        y: 0,
        z: 0,
    };

    let length = {
        x: 0,
        y: 10,
    };

    let geometry = new THREE.Geometry();

    geometry.vertices.push(new THREE.Vector3(min, min, 0));
    geometry.vertices.push(new THREE.Vector3(min, max, 0));
    geometry.vertices.push(new THREE.Vector3(max, max, 0));
    geometry.vertices.push(new THREE.Vector3(max, min, 0));

    //new Vector2 (0, 0), new Vector2 (0, 1), new Vector2 (1, 1),  new Vector2 (1, 0)

    // geometry.faceVertexUvs[ 0 ][ faceIndex ][ vertexIndex ]
    geometry.faces.push(new THREE.Face3(0, 1, 2));
    geometry.faceVertexUvs[0].push([new THREE.Vector2(0, 0),
        new THREE.Vector2(0, 1),
        new THREE.Vector2(1, 1)]);

    geometry.faces.push(new THREE.Face3(3, 0, 2));
    geometry.faceVertexUvs[0].push([new THREE.Vector2(1, 0),
        new THREE.Vector2(0, 0),
        new THREE.Vector2(1, 1)]);


    // apply the needed uvs
    //geometry.faceVertexUvs[0] = [];

    geometry.faceVertexUvs[0] = AnimatedFrame.getFrameCoords(0, 0);

    // apply the needed UVs to the quad
    geometry.computeFaceNormals();
    geometry.computeVertexNormals();
    let mat = new THREE.MeshBasicMaterial({
        color: tinycolor({
            r: 255,
            g: 255,
            b: 255
        }).toHexString(),
        wireframe: false,
        map: TextureStore.getTexture("tile")
    });
    mat.shading = THREE.FlatShading;
    mat.side = THREE.DoubleSide;

    let mesh = new THREE.Mesh(
        geometry,
        mat
    );

    scene.add(mesh);

    let object = new AnimatedObject();
    object.material = mat;
    object.geometry = geometry;
    object.mesh = mesh;
    object.addAnimation("default", [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
    object.addAnimation("backwards", [11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0]);
    object.startAnimation("default");
    ObjectStore.addObject(object);

}

export function buildSphere(material) {
    let mat;
    let quad;

    let totalWidth = Math.abs(farTopLeft.x) + Math.abs(farTopRight.x);
    let totalHeight = Math.abs(farTopLeft.y) + Math.abs(farBottomRight.y);
    let pointSize = totalWidth / 700;

    let r = 255;
    let g = 255;
    let b = 0;

    let geometry = new THREE.SphereGeometry(gRadius, 32, 32);
    let sphere = new THREE.Mesh(geometry, material);
    sphere.position.set(0,
        0,
        0);

    return sphere;
}

export function drawSolidSphere() {
    let mat;
    let quad;

    let totalWidth = Math.abs(farTopLeft.x) + Math.abs(farTopRight.x);
    let totalHeight = Math.abs(farTopLeft.y) + Math.abs(farBottomRight.y);
    let pointSize = totalWidth / 700;

    let r = 255;
    let g = 255;
    let b = 0;

    let geometry = new THREE.SphereGeometry(gRadius, 32, 32);
    let material = new THREE.MeshNormalMaterial({ color: 0xffff00, wireframe: false });
    let sphere = new THREE.Mesh(geometry, material);

    sphere.position.set(0,
        0,
        0);
    scene.add(sphere);
}

// I'm not sure what this is but it can probably go.
export function drawGuy() {
    let mat;
    let quad;
    let totalWidth = Math.abs(farTopLeft.x) + Math.abs(farTopRight.x);
    let totalHeight = Math.abs(farTopLeft.y) + Math.abs(farBottomRight.y);
    let loader = new THREE.JSONLoader();
    loader.load("/static/mesh/guy.json", function (geometry) {
        let material = new THREE.MeshLambertMaterial({ color: 0x55B663 });
        let mesh = new THREE.Mesh(geometry, material);
        mesh.scale.set(10, 10, 10);
        mesh.position.set(50, 0, 0);
        scene.add(mesh);
    });
}

function drawSphere() {
    let mat;
    let quad;

    let totalWidth = Math.abs(farTopLeft.x) + Math.abs(farTopRight.x);
    let totalHeight = Math.abs(farTopLeft.y) + Math.abs(farBottomRight.y);

    let pointSize = totalWidth / 700;
    let radius = pointSize * 20;

    let r = 255;
    let g = 255;
    let b = 0;

    // generate some random points on the sphere

    const sphereGroup = new THREE.Object3D();
    let sg = new THREE.Object3D();

    for (let i = 0; i < 200; i++) {
        mat = new THREE.MeshBasicMaterial({
            color: tinycolor({
                r: r,
                g: g,
                b: b
            }).toHexString(),
            wireframe: false
        });

        mat.shading = THREE.FlatShading;
        mat.side = THREE.DoubleSide;

        quad = new THREE.Mesh(
            new THREE.PlaneGeometry(pointSize, pointSize, 1, 1),
            mat
        );

        quad = new THREE.Mesh(
            new THREE.BoxGeometry(pointSize, pointSize, pointSize),
            mat
        );

        let phi = arandom(0, 2.0 * Math.PI);
        let theta = arandom(0, 2.0 * Math.PI);

        let x = Math.cos(theta) * Math.sin(phi) * gRadius;
        let y = Math.sin(theta) * Math.sin(phi) * gRadius;
        let z = Math.cos(phi) * gRadius;

        quad.position.set(x + origin.x,
            y + origin.y,
            z + origin.z);

        sg.add(quad);
    }
    sphereGroup.add(sg);
    scene.add(sphereGroup);
    sphereGroup.position.set(0, 0, 0);
}

function genLine(x1, y1, z1,
                 x2, y2, z2,
                 width,
                 material) {
    return drawTex4(
        x1,
        y1,
        z1,
        x1 + width,
        y1,
        z1,

        x2,
        y2,
        z2,

        x2 + width,
        y2,
        z2,
        material
    );
}

function drawQuadPoints(tR, tL, bR, bL) {
    let min = -100.0;
    let max = 100.0;

    let origin = {
        x: 0,
        y: 0,
        z: 0,
    };

    let length = {
        x: 0,
        y: 10,
    };

    let geometry = new THREE.Geometry();

    geometry.vertices.push(new THREE.Vector3(min, min, 0));
    geometry.vertices.push(new THREE.Vector3(min, max, 0));
    geometry.vertices.push(new THREE.Vector3(max, max, 0));
    geometry.vertices.push(new THREE.Vector3(max, min, 0));

    // geometry.faceVertexUvs[ 0 ][ faceIndex ][ vertexIndex ]
    geometry.faces.push(new THREE.Face3(0, 1, 2));
    geometry.faceVertexUvs[0].push([new THREE.Vector2(0, 0), new THREE.Vector2(0, 1), new THREE.Vector2(1, 1)]);

    geometry.faces.push(new THREE.Face3(3, 0, 2));
    geometry.faceVertexUvs[0].push([new THREE.Vector2(1, 0), new THREE.Vector2(0, 0), new THREE.Vector2(1, 1)]);

    // apply the needed UVs to the quad
    geometry.computeFaceNormals();
    geometry.computeVertexNormals();
    let mat = new THREE.MeshBasicMaterial({
        color: tinycolor({
            r: 255,
            g: 255,
            b: 255
        }).toHexString(),
        wireframe: false,
        map: TextureStore.getTexture("tile")
    });
    mat.shading = THREE.FlatShading;
    mat.side = THREE.DoubleSide;

    let mesh = new THREE.Mesh(
        geometry,
        mat
    );

    scene.add(mesh);
    let object = new AnimatedObject();
    object.update();
    ObjectStore.addObject(object);
}

// Add a static model at some position
export function drawModel(modelName, name) {
    let model = ModelStore.getModel(modelName);
    let geometry = model["geometry"];
    let materials = model["materials"];
    let object = new THREE.Mesh(geometry, new THREE.MeshFaceMaterial(materials));
    object.name = name;
    object.scale.x = object.scale.y = object.scale.z = 20.0;
    return object;
}

export function drawTriangle() {
    let geometry = new THREE.Geometry();
    let v1 = new THREE.Vector3(0, 0, 0);
    let v2 = new THREE.Vector3(10, 0, 0);
    let v3 = new THREE.Vector3(0, 10, 0);

    geometry.vertices.push(v1);
    geometry.vertices.push(v2);
    geometry.vertices.push(v3);

    geometry.faces.push(new THREE.Face3(0, 2, 1));
    let redMat = new THREE.MeshBasicMaterial({ color: 0xff0000 });
    let triangle = new THREE.Mesh(geometry, redMat);
    scene.add(triangle);
    return triangle;
}
